module.exports = __webpack_public_path__ + "img/Lego_Adults_sk.6e6109d1.png";